import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ChevronLeft, Users, Lock, MessageCircle, Heart, CheckCircle2 } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
const GuardianMode = () => {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-407">
      <Header data-id="element-408" />
      <main className="flex-grow py-8 px-4" data-id="element-409">
        <div className="max-w-4xl mx-auto" data-id="element-410">
          <div className="mb-6" data-id="element-411">
            <Link to="/dashboard" className="flex items-center text-emerald-700 hover:text-emerald-800 transition duration-300" data-id="element-412">
              <ChevronLeft className="h-5 w-5 mr-1" data-id="element-413" />
              Back to Dashboard
            </Link>
          </div>
          {/* Guardian Mode Header */}
          <div className="bg-gradient-to-r from-emerald-800 to-teal-700 rounded-xl p-8 mb-8 text-white shadow-md" data-id="element-414">
            <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-415">
              <div className="mb-6 md:mb-0" data-id="element-416">
                <h1 className="text-3xl font-bold mb-3 flex items-center" data-id="element-417">
                  <Shield className="h-6 w-6 mr-2" data-id="element-418" />
                  Guardian Mode
                </h1>
                <p className="text-emerald-100 max-w-xl" data-id="element-419">
                  Your guardian was assigned during registration and has full
                  oversight of your marriage journey, honoring our traditions
                  while embracing modern connections.
                </p>
              </div>
              <div className="flex-shrink-0" data-id="element-420">
                <button className="bg-white text-emerald-800 hover:bg-emerald-100 font-bold py-3 px-6 rounded-lg transition duration-300" data-id="element-421">
                  Manage Guardian Settings
                </button>
              </div>
            </div>
          </div>
          {/* Main Content */}
          <div className="space-y-8" data-id="element-422">
            {/* How It Works */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-423">
              <div className="p-6" data-id="element-424">
                <h2 className="text-2xl font-bold text-emerald-900 mb-6" data-id="element-425">
                  How Guardian Mode Works
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-426">
                  <div className="bg-amber-50 p-5 rounded-lg text-center" data-id="element-427">
                    <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-428">
                      <Users className="h-6 w-6 text-amber-700" data-id="element-429" />
                    </div>
                    <h3 className="font-semibold text-amber-900 mb-2" data-id="element-430">
                      Invite Family
                    </h3>
                    <p className="text-sm text-gray-700" data-id="element-431">
                      Invite a parent, sibling, or trusted family member to be
                      your guardian in the app.
                    </p>
                  </div>
                  <div className="bg-amber-50 p-5 rounded-lg text-center" data-id="element-432">
                    <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-433">
                      <Lock className="h-6 w-6 text-amber-700" data-id="element-434" />
                    </div>
                    <h3 className="font-semibold text-amber-900 mb-2" data-id="element-435">
                      Set Permissions
                    </h3>
                    <p className="text-sm text-gray-700" data-id="element-436">
                      Choose what your guardian can see and do, from viewing
                      matches to reading conversations.
                    </p>
                  </div>
                  <div className="bg-amber-50 p-5 rounded-lg text-center" data-id="element-437">
                    <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-438">
                      <MessageCircle className="h-6 w-6 text-amber-700" data-id="element-439" />
                    </div>
                    <h3 className="font-semibold text-amber-900 mb-2" data-id="element-440">
                      Family Involvement
                    </h3>
                    <p className="text-sm text-gray-700" data-id="element-441">
                      When ready, include your guardian in conversations with
                      potential matches and their families.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Guardian Permissions */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-442">
              <div className="p-6" data-id="element-443">
                <h2 className="text-2xl font-bold text-emerald-900 mb-6" data-id="element-444">
                  Guardian Permissions
                </h2>
                <p className="text-gray-700 mb-6" data-id="element-445">
                  You have full control over what your guardian can see and do.
                  Choose the level of involvement that feels right for you:
                </p>
                <div className="space-y-4" data-id="element-446">
                  <div className="border border-gray-200 rounded-lg p-4 hover:border-emerald-300 transition duration-300" data-id="element-447">
                    <div className="flex items-start" data-id="element-448">
                      <input type="radio" id="basic" name="guardianLevel" className="mt-1 h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-449" />
                      <div className="ml-3" data-id="element-450">
                        <label htmlFor="basic" className="font-medium text-gray-900 block mb-1" data-id="element-451">
                          Basic Oversight
                        </label>
                        <p className="text-sm text-gray-600" data-id="element-452">
                          Your guardian can see your matches but cannot view
                          conversations. They'll be notified when you receive a
                          Khitbah request.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4 hover:border-emerald-300 transition duration-300" data-id="element-453">
                    <div className="flex items-start" data-id="element-454">
                      <input type="radio" id="moderate" name="guardianLevel" className="mt-1 h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" defaultChecked data-id="element-455" />
                      <div className="ml-3" data-id="element-456">
                        <label htmlFor="moderate" className="font-medium text-gray-900 block mb-1" data-id="element-457">
                          Conversation Access
                        </label>
                        <p className="text-sm text-gray-600" data-id="element-458">
                          Your guardian can view your conversations in read-only
                          mode, but cannot participate directly. Good for
                          maintaining privacy while allowing supervision.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="border border-gray-200 rounded-lg p-4 hover:border-emerald-300 transition duration-300" data-id="element-459">
                    <div className="flex items-start" data-id="element-460">
                      <input type="radio" id="full" name="guardianLevel" className="mt-1 h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300" data-id="element-461" />
                      <div className="ml-3" data-id="element-462">
                        <label htmlFor="full" className="font-medium text-gray-900 block mb-1" data-id="element-463">
                          Full Involvement
                        </label>
                        <p className="text-sm text-gray-600" data-id="element-464">
                          Your guardian can participate in conversations,
                          especially during the Khitbah process. Ideal for the
                          formal stages of marriage discussion.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Invite Guardian */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-465">
              <div className="p-6" data-id="element-466">
                <h2 className="text-2xl font-bold text-emerald-900 mb-6" data-id="element-467">
                  Invite a Guardian
                </h2>
                <div className="space-y-4" data-id="element-468">
                  <div data-id="element-469">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-470">
                      Guardian's Name
                    </label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500" placeholder="Enter your guardian's name" data-id="element-471" />
                  </div>
                  <div data-id="element-472">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-473">
                      Relationship
                    </label>
                    <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500" data-id="element-474">
                      <option value="" data-id="element-475">Select relationship</option>
                      <option value="father" data-id="element-476">Father</option>
                      <option value="mother" data-id="element-477">Mother</option>
                      <option value="brother" data-id="element-478">Brother</option>
                      <option value="sister" data-id="element-479">Sister</option>
                      <option value="uncle" data-id="element-480">Uncle</option>
                      <option value="aunt" data-id="element-481">Aunt</option>
                      <option value="other" data-id="element-482">Other</option>
                    </select>
                  </div>
                  <div data-id="element-483">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-484">
                      Phone Number
                    </label>
                    <input type="tel" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500" placeholder="Enter phone number" data-id="element-485" />
                  </div>
                  <div data-id="element-486">
                    <label className="block text-gray-700 font-medium mb-2" data-id="element-487">
                      Personal Message
                    </label>
                    <textarea className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 h-24" placeholder="Add a personal message to your invitation..." data-id="element-488"></textarea>
                  </div>
                </div>
                <div className="mt-6" data-id="element-489">
                  <button className="bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 px-6 rounded-lg transition duration-300 w-full" data-id="element-490">
                    Send Guardian Invitation
                  </button>
                </div>
              </div>
            </div>
            {/* Benefits */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-491">
              <div className="p-6" data-id="element-492">
                <h2 className="text-2xl font-bold text-emerald-900 mb-6" data-id="element-493">
                  Benefits of Guardian Mode
                </h2>
                <div className="space-y-4" data-id="element-494">
                  <div className="flex items-start" data-id="element-495">
                    <div className="bg-emerald-100 p-2 rounded-full mr-4" data-id="element-496">
                      <CheckCircle2 className="h-5 w-5 text-emerald-700" data-id="element-497" />
                    </div>
                    <div data-id="element-498">
                      <h3 className="font-medium text-gray-900" data-id="element-499">
                        Honor Traditions
                      </h3>
                      <p className="text-gray-700 mt-1" data-id="element-500">
                        Respect our cultural values by involving family in the
                        marriage process while using modern technology.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-501">
                    <div className="bg-emerald-100 p-2 rounded-full mr-4" data-id="element-502">
                      <CheckCircle2 className="h-5 w-5 text-emerald-700" data-id="element-503" />
                    </div>
                    <div data-id="element-504">
                      <h3 className="font-medium text-gray-900" data-id="element-505">
                        Added Security
                      </h3>
                      <p className="text-gray-700 mt-1" data-id="element-506">
                        Having a guardian adds an extra layer of protection and
                        guidance during your search.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-507">
                    <div className="bg-emerald-100 p-2 rounded-full mr-4" data-id="element-508">
                      <CheckCircle2 className="h-5 w-5 text-emerald-700" data-id="element-509" />
                    </div>
                    <div data-id="element-510">
                      <h3 className="font-medium text-gray-900" data-id="element-511">
                        Smoother Transitions
                      </h3>
                      <p className="text-gray-700 mt-1" data-id="element-512">
                        When you're ready for the Khitbah process, your family
                        is already involved and informed.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-513">
                    <div className="bg-emerald-100 p-2 rounded-full mr-4" data-id="element-514">
                      <CheckCircle2 className="h-5 w-5 text-emerald-700" data-id="element-515" />
                    </div>
                    <div data-id="element-516">
                      <h3 className="font-medium text-gray-900" data-id="element-517">
                        Builds Trust
                      </h3>
                      <p className="text-gray-700 mt-1" data-id="element-518">
                        Potential matches and their families will appreciate
                        your commitment to proper Islamic etiquette.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Family Chat Preview */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-519">
              <div className="p-6" data-id="element-520">
                <h2 className="text-2xl font-bold text-emerald-900 mb-6" data-id="element-521">
                  Family Chat Feature
                </h2>
                <div className="bg-amber-50 p-5 rounded-lg mb-6" data-id="element-522">
                  <div className="flex items-start" data-id="element-523">
                    <Heart className="h-5 w-5 text-amber-700 mr-2 mt-1" data-id="element-524" />
                    <p className="text-amber-800" data-id="element-525">
                      When both parties are interested, you can initiate a
                      Family Chat that includes guardians from both sides to
                      discuss the next steps in the marriage process.
                    </p>
                  </div>
                </div>
                <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-526">
                  <div className="bg-emerald-700 text-white p-3" data-id="element-527">
                    <h3 className="font-medium" data-id="element-528">Family Chat Preview</h3>
                  </div>
                  <div className="p-4 bg-gray-50 h-48" data-id="element-529">
                    <div className="space-y-3" data-id="element-530">
                      <div className="flex justify-start" data-id="element-531">
                        <div className="bg-white border border-gray-200 rounded-lg p-3 max-w-xs" data-id="element-532">
                          <p className="text-sm text-gray-800" data-id="element-533">
                            Assalamu alaikum. Thank you for accepting our family
                            into this conversation. We're happy to discuss the
                            next steps.
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-534">
                            Ahmed's Father • 2:30 PM
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-end" data-id="element-535">
                        <div className="bg-emerald-100 rounded-lg p-3 max-w-xs" data-id="element-536">
                          <p className="text-sm text-emerald-900" data-id="element-537">
                            Walaikum assalam. We're pleased to meet you as well.
                            Our daughter has spoken highly of Ahmed.
                          </p>
                          <p className="text-xs text-emerald-700 mt-1" data-id="element-538">
                            Sarah's Mother • 2:35 PM
                          </p>
                        </div>
                      </div>
                      <div className="flex justify-start" data-id="element-539">
                        <div className="bg-white border border-gray-200 rounded-lg p-3 max-w-xs" data-id="element-540">
                          <p className="text-sm text-gray-800" data-id="element-541">
                            Perhaps we could arrange a meeting between our
                            families to discuss this further?
                          </p>
                          <p className="text-xs text-gray-500 mt-1" data-id="element-542">
                            Ahmed's Father • 2:40 PM
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-6 text-center" data-id="element-543">
                  <button className="bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-2 px-4 rounded-lg transition duration-300" data-id="element-544">
                    Learn More About Family Chat
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-545" />
    </div>;
};
export default GuardianMode;